import { useMemo } from 'react';

import { useBetSlice } from '@pp/core/src/store/slices/bets/selectors';
import type { BetType } from '@pp/core/src/store/slices/bets/types';

import { useHighflyerStateSlice } from '../../../store/slices/highflyerState/selectors';

export const useIsBetConfirmedConnected = (betCode: number): boolean => {
  const bets = useBetSlice.bets() as BetType | undefined;
  const earlyBetStatus = useHighflyerStateSlice.hasEarlyBets(betCode);
  return useMemo(() => {
    const betSpotValue = bets?.betSpots?.[betCode]?.value || 0;
    const isBetConfirmed = betSpotValue > 0;
    return isBetConfirmed || earlyBetStatus;
  }, [bets?.betSpots, betCode, earlyBetStatus]);
};
